/* eslint-disable react/jsx-props-no-spreading */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import Typography from "../../../../components/common/new/Typography/Typography";
// import { selectOSNamesByUserRole } from "../../../../redux/selectors/user";
import Dashboard from "./Dashboard/Dashboard";
import { getFormattedData } from "./utils";
import FriendDetailCard from "./FriendDetailCards/DetailCards";
import Friends from "../../../../services/api/friend";
import useUserConfig from "../../../../hooks/useUserConfig";
import Loader from "../../../../components/common/Loader/Loader";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    margin: "0 -2.65%",
    backgroundColor: "#F7F7F9",
  },
  leftContainer: {
    flex: 1,
    minWidth: 150,
  },
  rightContainer: {
    display: "flex",
    flex: 4,
  },
  tabsStyle: {
    textTransform: "uppercase",
    cursor: "pointer",
    fontSize: "10px",
    font: "normal 600 12px",
    paddingBottom: "8px",
    paddingTop: "8px",
  },
  memberIdStyle: {
    color: "#183053",
    fontWeight: "600",
  },
};

function FriendDetail() {
  const TITLE = "Friend Details - BSG";
  const [friendInfo, setFriendInfo] = useState({});
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // const userOSNames = useSelector(selectOSNamesByUserRole);
  const { id } = useParams();
  const hasPermission = useUserConfig();

  const fetchFriendData = async (friendId) => {
    try {
      setIsLoading(true);
      const promiseAPIs = [
        Friends.friendView(friendId),
        Friends.getAttendanceByFriendId(friendId),
      ];
      const [friendInfoData, attendanceData] = await Promise.all(promiseAPIs);

      // console.log("NOT", attendanceData);
      setFriendInfo(friendInfoData.data);
      setAttendanceInfo(getFormattedData(attendanceData.data));
      setIsLoading(false);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFriendData(id);
    }
  }, [id]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 10000);
  }, []);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box display="flex" justifyContent="space-between" mb={4}>
        <Typography variant="small" weight={500} color="#183053">
          Friend ID: {friendInfo.friendId}
        </Typography>
        <Typography variant="small" weight={500} color="#183053">
          {/* {Object?.values(userOSNames)?.join("/")} */}
          {[
            friendInfo?.areaName,
            friendInfo?.zoneName,
            friendInfo?.regionName,
            friendInfo?.chapterName,
            friendInfo?.districtName,
            friendInfo?.blockName,
          ]
            .filter(Boolean)
            .join("/ ")}
        </Typography>
      </Box>
      <Box style={styles.container}>
        <Box style={styles.leftContainer}>
          <FriendDetailCard
            friendInfo={friendInfo}
            hasPermission={hasPermission}
          />
        </Box>
        <Box style={styles.rightContainer}>
          <Dashboard
            friendId={friendInfo.friendId}
            attendanceInfo={attendanceInfo}
            friendInfo={friendInfo}
          />
        </Box>
        {isLoading && <Loader />}
      </Box>
    </>
  );
}

export default FriendDetail;
